// ./src/components/generic/MediaSelector/tabs/audioLibraryRules.ts
//
// Mirrors of the API's audio-library rules the picker needs (`eventsmagic-api/src/boundary/audioLibrary.ts`) —
// `check-audio-library` asserts they match.

/** The shortest query the API searches; the picker waits for it rather than sending one to be refused. */
export const AUDIO_LIBRARY_MIN_QUERY = 3;
